// @ts-nocheck
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { RadioGroupProps } from "@store/MobiusOverrides/RadioGroup/RadioGroup";
import { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { WishListSharingStatusStyles } from "@store/Overrides/Components/WishListSharingStatus";
import { imageStyles } from "@store/Themes/common/mixins/image";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { tableGetEllipsisCellProps, tableProps } from "@store/Themes/common/props/table";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusUpdateStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface WishListTableProps {
    wrapper?: InjectableCss;
    dataTable?: DataTableProps;
    listNameHeader?: DataTableHeaderProps;
    listNameDescriptionCell?: DataTableCellProps;
    listDescriptionText?: TypographyProps;
    dateHeader?: DataTableHeaderProps;
    dateCell?: DataTableCellProps;
    lastUpdatedText?: TypographyProps;
    itemsHeader?: DataTableHeaderProps;
    itemsCell?: DataTableCellProps;
    itemsWrapper?: InjectableCss;
    itemsImageWrapper?: InjectableCss;
    itemProductImage?: ProductImageStyles;
    statusHeader?: DataTableHeaderProps;
    statusCell?: DataTableCellProps;
    sharingStatus?: WishListSharingStatusStyles;
    actionsHeader?: DataTableHeaderProps;
    actionsCell?: DataTableCellProps;
    actionsWrapper?: InjectableCss;
    actionButton?: ButtonPresentationProps;
    actionAddToCartLink?: LinkPresentationProps;
    actionLeaveLink?: LinkPresentationProps;
    actionDeleteLink?: LinkPresentationProps;
}

const smallCellProps: DataTableCellProps = {
    css: css`
        padding-top: ${pxToRem(8)};
        padding-bottom: ${pxToRem(8)};
    `,
};

export const wishListTableProps: WishListTableProps = {
    wrapper: tableProps.wrapper,
    dataTable: {},
    listNameHeader: {},
    listNameDescriptionCell: tableGetEllipsisCellProps(240),
    listDescriptionText: {},
    dateHeader: {},
    dateCell: tableGetEllipsisCellProps(165),
    lastUpdatedText: {},
    itemsHeader: {},
    itemsCell: smallCellProps,
    itemsWrapper: {
        css: css`
            display: flex;
            gap: ${pxToRem(5)};
        `,
    },
    itemsImageWrapper: {
        css: css`
            ${x => imageStyles(x.theme.design.product.image.small.ratio)}
            width: ${pxToRem(50)};
            flex: 0 0 auto;
        `,
    },
    itemProductImage: {
        linkWrappingImage: {
            css: css`
                ${focusUpdateStyles(true)}
            `,
        },
    },
    statusHeader: {},
    statusCell: tableGetEllipsisCellProps(190),
    sharingStatus: {},
    actionsHeader: tableProps.tightHeader,
    actionsCell: smallCellProps,
    actionsWrapper: {},
    actionButton: tableProps.button,
    actionAddToCartLink: productLineProps.addToListLink,
    actionLeaveLink: productLineProps.leaveListLink,
    actionDeleteLink: productLineProps.removeLink,
};

export interface WishListDetailsProps {
    checkbox?: CheckboxPresentationProps;
    radioGroup?: RadioGroupProps;
}

export const wishListDetailsProps: WishListDetailsProps = {
    checkbox: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            cursor: pointer;

            @media print {
                display: none;
            }
        `,
    },
    radioGroup: {
        horizontal: true,
        css: css`
            ${x => x.theme.radio.groupDefaultProps?.css}
        `,
    },
};
